import { render, staticRenderFns } from "./createActive.vue?vue&type=template&id=9834548a&scoped=true&"
import script from "./createActive.vue?vue&type=script&lang=js&"
export * from "./createActive.vue?vue&type=script&lang=js&"
import style0 from "./createActive.vue?vue&type=style&index=0&id=9834548a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9834548a",
  null
  
)

export default component.exports